import Cookies from 'js-cookie';
import { getApiUrl, transformToQueryString } from '../../utils';

const QUERY_STORAGE = {};

const ApiFilter = ({
  _accessToken,
  _instanceToken,
  appSessionId,
  endpoint,
  render,
}) => {
  const CONFIG_API_URL = getApiUrl(endpoint?.apiConfig, 'apiConfig');
  const FILTER_API_URL = getApiUrl(endpoint?.apiSite, 'apiSite');
  const instanceToken = _instanceToken || Cookies.get('instance_token');
  const accessToken = _accessToken || Cookies.get('access_token_ma');

  const fetchConfig = (configId) => fetch(`${CONFIG_API_URL}/v1/configs/${configId}`, {
  })
    .then((response) => {
      if (response.status !== 200) {
        throw new Error(`Fetch failure, http status ${response.status}`);
      }
      return response.json();
    })
    .then((response) => response.map(({ id, config }) => ({
      id,
      ...JSON.parse(config),
    })))
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.log('error', e);
      return false;
    });

  const fetchThemeConfig = (configId) => fetch(`${CONFIG_API_URL}/v1/theme-configs/${configId}`, {
  })
    .then((response) => {
      if (response.status !== 200) {
        throw new Error(`Fetch failure, http status ${response.status}`);
      }
      return response.json();
    })
    .then((response) => response.map(({ id, config }) => ({
      id,
      ...JSON.parse(config),
    })))
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.log('error', e);
      return false;
    });

  const fetchContentFilter = (params) => {
    const filterApiType = params.type === 'actors'
      ? '/v2/actor-filters'
      : '/v2/release-filters';

    const queryPath = `${FILTER_API_URL}${filterApiType}${transformToQueryString(params)}`;

    if (Object.prototype.hasOwnProperty.call(QUERY_STORAGE, queryPath)) {
      return Promise.resolve(QUERY_STORAGE[queryPath]);
    }

    return fetch(queryPath, {
      headers: {
        // eslint-disable-next-line quote-props
        'Instance': instanceToken,
        ...(accessToken && { Authorization: accessToken }),
        ...(appSessionId && { 'X-APP-SESSION-ID': appSessionId }),
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(`Fetch failure, http status ${response.status}`);
        }
        const jsonResponse = response.json();
        QUERY_STORAGE[queryPath] = jsonResponse;
        return jsonResponse;
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.log('error', e);
        return false;
      });
  };
  return render({ fetchConfig, fetchContentFilter, fetchThemeConfig });
};

export default ApiFilter;
